import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Resiliência a extensões/recursos de tradução (Google Translate etc.): eles
// mutam o DOM por fora do React (envolvem textos em <font>), e o React então
// quebra com "NotFoundError: Failed to execute 'removeChild' on 'Node'" ao
// reconciliar — foi o erro que travava o drawer "Dados do contato" (ambos
// inboxes). Tornamos removeChild/insertBefore tolerantes quando o nó já não é
// mais filho esperado, deixando a árvore sobreviver à dessincronia.
if (typeof Node === 'function' && Node.prototype) {
  const _removeChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child && child.parentNode !== this) {
      return child;
    }
    return _removeChild.apply(this, arguments);
  };
  const _insertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      return Node.prototype.appendChild.call(this, newNode);
    }
    return _insertBefore.apply(this, arguments);
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// PWA: registra o service worker (public/service-worker.js — passthrough sem
// cache, só instalabilidade + notificações nativas). Apenas no build de
// produção: em dev o SW atrapalha o hot-reload do CRA.
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .catch((err) => console.warn('[PWA] service worker não registrado:', err));
  });

  // Clique numa notificação nativa com o app aberto: o SW envia o CTA por
  // postMessage e foca a janela — aqui aplicamos a navegação. v1: leva para
  // a tela certa (open_url usa o caminho; open_chat cai no inbox do canal);
  // a seleção fina do chat continua pelo painel de notificações.
  navigator.serviceWorker.addEventListener('message', (event) => {
    const msg = event?.data;
    if (!msg || msg.type !== 'notification-click') return;
    const cta = msg.cta || null;
    try {
      if (cta?.action === 'open_url' && cta?.payload?.url) {
        window.location.assign(cta.payload.url);
      } else if (cta?.action === 'open_chat') {
        const channel = cta?.payload?.channel;
        window.location.assign(channel === 'wa_business' ? '/wa-business' : '/inbox');
      }
    } catch (e) { /* best-effort */ }
  });
}
